export default function validateForm(fields, form, items) {
    const errors = {};

    for (const field of fields) {
        const value = form[field.name];

        // Required
        if (
            field.required &&
            (value === undefined || value === null || value === "")
        ) {
            errors[field.name] = `${field.label} is required.`;
            continue;
        }

        // Minimum Length
        if (field.minLength && value && value.length < field.minLength) {
            errors[field.name] =
                `${field.label} must be at least ${field.minLength} characters.`;
            continue;
        }

        // Maximum Length
        if (field.maxLength && value && value.length > field.maxLength) {
            errors[field.name] =
                `${field.label} must not exceed ${field.maxLength} characters.`;
        }

        // Maximum Length
        if (field.unique && value && items?.length) {
            const valueId = form.id;
            const existingItem = items.find(
                (o) => o[field.name] === value && (o.id !== valueId || !valueId)
            );
            if (existingItem) {
                errors[field.name] = `${field.label} already exists.`;
            }
        }
    }

    return errors;
}
